const Home = () => {
    return (
        <>
            <section id="hero" className="flex flex-col justify-center items-center">
                <div className="hero-container" data-aos="fade-in">
                    <h1>James Baker</h1>
                    {/* <p>I'm <span className="typed" data-typed-items="Designer, Developer, Freelancer, Photographer"></span></p> */}
                </div>
            </section>
        </>
    )
}
export default Home;
